import { createGlobalState } from 'react-use';

const useVoiceState = createGlobalState<'INIT' | 'IDLE' | 'SPEAKING' | 'LISTENING'>('INIT');

export default useVoiceState;
